import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Dashboard = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="dashboard icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9998 13.3332C19.263 13.3332 18.6666 12.7368 18.6666 12C18.6666 11.2626 19.263 10.6668 19.9998 10.6668C20.7372 10.6668 21.3336 11.2626 21.3336 12C21.3336 12.7368 20.7372 13.3332 19.9998 13.3332ZM17.7732 8.6664C17.4048 8.0286 17.6238 7.2132 18.2622 6.8448C18.9 6.4764 19.7148 6.6954 20.0838 7.3332C20.4516 7.971 20.2332 8.7864 19.5948 9.1548C18.957 9.5232 18.1416 9.3048 17.7732 8.6664ZM17.1564 5.7384C16.7874 6.3774 15.9714 6.5952 15.3336 6.2262C14.6952 5.8584 14.478 5.043 14.8464 4.4052C15.213 3.7668 16.0302 3.5496 16.668 3.9168C17.3064 4.2852 17.5236 5.1 17.1564 5.7384ZM14.0676 19.9866C13.3986 21.147 11.9154 21.5442 10.7556 20.8746C9.5976 20.2068 9.2004 18.7224 9.867 17.5638C10.5372 16.4052 15.0912 10.0608 16.0002 10.6668C16.9092 11.2734 14.736 18.8292 14.0676 19.9866ZM8.6664 6.2262C8.0286 6.5952 7.2144 6.3774 6.846 5.7384C6.4782 5.1 6.6978 4.2834 7.3338 3.915C7.9728 3.5496 8.787 3.7668 9.1578 4.4034C9.5262 5.0418 9.306 5.8584 8.6664 6.2262ZM6.2268 8.6664C5.8596 9.3048 5.0454 9.5232 4.4064 9.1536C3.768 8.7864 3.5508 7.9686 3.9162 7.332C4.2876 6.6954 5.1018 6.4764 5.7408 6.8424C6.3792 7.2108 6.5964 8.0286 6.2268 8.6664ZM4.0002 13.3332C3.2628 13.3332 2.6664 12.7368 2.6664 12C2.6664 11.2626 3.2628 10.6668 4.0002 10.6668C4.737 10.6668 5.3334 11.2626 5.3334 12C5.3334 12.7368 4.737 13.3332 4.0002 13.3332ZM12.0012 2.6652C12.7374 2.6664 13.3338 3.2628 13.3362 3.9996C13.3362 4.737 12.7374 5.3334 12 5.3334C11.2626 5.3334 10.6662 4.737 10.6662 3.9996C10.6662 3.2628 11.2656 2.6664 12.0012 2.6652ZM12 0C5.3724 0 0 5.3724 0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0Z"
    />
  </svg>
)
